import React, { useReducer } from 'react';
import authContext from './authContext.js';
import authReducer from './authReducer.js';
import { USUARIO_AUTENTICADO, LOGIN_EXITOSO, CASO_BASE } from '../../types/index.js';

const AuthState = ({ children }) => {

    const initialState = {
        token: null,
        autenticado: null,
        puntoVenta: "",
        usuario: "",
        es_pin: false,
        cambiar_pin: false,
        uid: "",
        tiene_2fa: false,
        tipo_modelo: null,
    }

    // DEFINICIÓN CASO BASE
    const casoBase = parametrosRecibidos => {  // const NOMBRE_FUNCION = PARAMETROS(1 objeto) => {
        //IMPRIME
        //OPERACIONES
        //COSAS LOCALES
        // { CÓDIGO DE LA FUCIÓN }

        /*-----------------------*/
        //INTERACTUAR CON EL HOOK / CONTEXTO
        //Para modificar los datos del hook usamos "Dispatch"

        //type = Identificador o palabra reservada
        dispatch({
            type: CASO_BASE,
            payload: parametrosRecibidos
        })
        //payload = Conjunto de datos que se le envían al reducer para actualizar, procesar, guardar, etc.

    }                                   // } //Cierre de la función


    //
    const iniciarSesion = async datos => {

        dispatch({
            type: LOGIN_EXITOSO,
            payload: datos
        })
    }


    //
    const usuarioAutenticado = nombre => {  //> [Función del Reducer]
        dispatch({
            type: USUARIO_AUTENTICADO,
            payload: nombre
        })
    }

    //Definir el reducer
    const [state, dispatch] = useReducer(authReducer, initialState);

    return (
        <authContext.Provider
            value={{
                token: state.token,
                autenticado: state.autenticado,
                usuario: state.usuario,
                puntoVenta: state.puntoVenta,
                es_pin: state.es_pin,
                cambiar_pin: state.cambiar_pin,
                uid: state.uid,
                tiene_2fa: state.tiene_2fa,
                tipo_modelo: state.tipo_modelo,
                usuarioAutenticado,
                iniciarSesion,
                casoBase
            }}
        >
            {children}
        </authContext.Provider>
    );
}

export default AuthState;
